import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d897fbc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "miniAppShare" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = {
  key: 0,
  class: "sc_div"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "sc_div"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确 定")

import pageTitle from '@/components/pageTitle.vue';
  import { ref, onMounted, getCurrentInstance } from 'vue';
  import { ElMessage, ElMessageBox } from 'element-plus';
  import { getShareList, editShareDetail } from '@/axios/smartMarket';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'miniAppShare',
  setup(__props) {

  let { proxy } = getCurrentInstance() as any;

  let dataList = ref([]);
  let form = ref({})
  let showDia  = ref(false)

  onMounted(()=>{
    getlist();
  })

  function getlist(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    getShareList({
      brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id
    }).then((data:any) => {
      dataList.value = data[0] ? data :  [];
    }).catch(err => {})
  }
  
  //图片删除
  function delImg(num:number){
    if(num == 1){
      form.value.friends_share_pic = '';
    }
    else{
      form.value.share_pic = '';
    }
  }
  //图片上传
  function beforeAvatarUpload(val:any){
    console.log(val)
    if(val.type.includes('jpeg') || val.type.includes('jpg') || val.type.includes('png')){
      
      let formdata = new FormData();
      formdata.append('file',val);
      formdata.append('project','om');
      formdata.append('modular','peelerCurrency');
      formdata.append('file_type',val.type.includes('image')?'image':'video');
      let urls = `${proxy?.$uploadUrl}/yc_upload/upload/uploads`;
      let xml = new window.XMLHttpRequest();
      xml.open('post',urls,true)
      xml.send(formdata);
      xml.onreadystatechange = function() {
        if(xml.readyState==4 && xml.status==200){
          let infos = JSON.parse(xml.response);
          console.log(infos)
          form.value.friends_share_pic = infos.data.url;
        }
      }
    }
    else{
      ElMessage('请选择推荐格式文件')
    }
    return false;
  }
  function beforeAvatarUploadSh(val:any){
    console.log(val)
    if(val.type.includes('jpeg') || val.type.includes('jpg') || val.type.includes('png')){
      
      let formdata = new FormData();
      formdata.append('file',val);
      formdata.append('project','om');
      formdata.append('modular','peelerCurrency');
      formdata.append('file_type',val.type.includes('image')?'image':'video');
      let urls = `${proxy?.$uploadUrl}/yc_upload/upload/uploads`;
      let xml = new window.XMLHttpRequest();
      xml.open('post',urls,true)
      xml.send(formdata);
      xml.onreadystatechange = function() {
        if(xml.readyState==4 && xml.status==200){
          let infos = JSON.parse(xml.response);
          console.log(infos)
          form.value.share_pic = infos.data.url;
        }
      }
    }
    else{
      ElMessage('请选择推荐格式文件')
    }
    return false;
  }
  function edits(val:any){
    if(val){
      form.value = JSON.parse(JSON.stringify(val));
    }
    showDia.value = true;
  }
  function closeInfo(){
    form.value = {};
    showDia.value = false;
  }
  function formClick(){
    editShareDetail(form.value).then(data => {
      ElMessage('编辑成功')
      getlist();
      closeInfo();
    }).catch(err => {})
  }

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_CircleClose = _resolveComponent("CircleClose")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(pageTitle, { title: "分享配置" }),
    _createVNode(_component_el_table, {
      data: _unref(dataList),
      border: "",
      style: {"width":"80%","margin":"20px auto"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "friends_share_words",
          label: "好友代付分享文案"
        }),
        _createVNode(_component_el_table_column, {
          prop: "",
          label: "好友代付分享图片"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("img", {
              src: scope.row.friends_share_pic,
              class: "imgs"
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "share_words",
          label: "小程序分享文案"
        }),
        _createVNode(_component_el_table_column, {
          label: "小程序分享图片",
          width: "270px"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("img", {
              src: scope.row.share_pic,
              class: "imgs"
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "编辑",
          width: "270px"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              onClick: ($event: any) => (edits(scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      title: _unref(form).id?'编辑':'新增',
      modelValue: _unref(showDia),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(showDia) ? (showDia).value = $event : showDia = $event)),
      onClose: closeInfo
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(form),
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "好友代付分享文案" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(form).friends_share_words,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).friends_share_words) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "好友代付分享图片" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_unref(form).friends_share_pic)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_el_icon, {
                          class: "el-icon-circle-close",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (delImg(1)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CircleClose)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("img", {
                          src: _unref(form).friends_share_pic,
                          class: "imgs"
                        }, null, 8, _hoisted_6)
                      ]))
                    : (_openBlock(), _createBlock(_component_el_upload, {
                        key: 1,
                        "show-file-list": false,
                        class: "avatar-uploader",
                        action: "",
                        "before-upload": beforeAvatarUpload
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { class: "el-icon-plus avatar-uploader-icon" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "小程序分享文案" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(form).share_words,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).share_words) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "小程序分享图片" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_unref(form).share_pic)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_el_icon, {
                          class: "el-icon-circle-close",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (delImg(2)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CircleClose)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("img", {
                          src: _unref(form).share_pic,
                          class: "imgs"
                        }, null, 8, _hoisted_8)
                      ]))
                    : (_openBlock(), _createBlock(_component_el_upload, {
                        key: 1,
                        "show-file-list": false,
                        class: "avatar-uploader",
                        action: "",
                        "before-upload": beforeAvatarUploadSh
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { class: "el-icon-plus avatar-uploader-icon" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, { onClick: closeInfo }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: formClick
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})